var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-giswms-map",class:{
    'main-giswms-map': true,
    'content-devx': _vm.nameMap === 'createObservationParcel' ||
      _vm.nameMap === 'viewObservationParcel'
  }},[_c('div',{staticClass:"content-gis-map"},[((_vm.treeLocations.length !== 0))?_c('div',{style:(_vm.minHeight),attrs:{"id":`${_vm.nameMap}_${_vm.initialDate}`}}):_c('div',{staticStyle:{"display":"block","text-align":"center"}},[_vm._v("\n      "+_vm._s(_vm.$t('GISGeoJsonMap_not_locations'))+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }